if (!customElements.get('ses-max-preorder')) {
  customElements.define('ses-max-preorder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const radios = [...this.querySelectorAll('.ses-max__options input[type="radio"]')];
      const select = this.querySelector('select[name="id"]');
      const scope = document.getElementById(`MainProduct-${this.dataset.section}`);
      const sync = (radio, updateUrl = false) => {
        if (!radio) return;
        radio.checked = true;
        select.value = radio.value;
        this.querySelector('[data-max-price]').textContent = radio.dataset.price;
        this.querySelector('[data-max-capacity]').textContent = radio.closest('label').querySelector('strong').textContent;
        const compare = this.querySelector('[data-max-compare]');
        compare.textContent = radio.dataset.compare;
        compare.hidden = !radio.dataset.compare;
        const available = radio.dataset.available === 'true';
        const button = this.querySelector('button[name="add"]');
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
        if (scope) {
          const firstSlide = scope.querySelector('.product__media-item');
          const primaryImage = firstSlide?.querySelector('.product__media img');
          if (primaryImage && radio.dataset.image) {
            primaryImage.removeAttribute('srcset');
            primaryImage.src = radio.dataset.image;
            primaryImage.alt = radio.dataset.imageAlt;
            const modal = document.getElementById(`ProductModal-${this.dataset.section}`);
            const mediaId = firstSlide.querySelector('.product__media-toggle')?.dataset.mediaId;
            const modalImage = mediaId && modal?.querySelector(`img[data-media-id="${mediaId}"]`);
            if (modalImage) {
              modalImage.removeAttribute('srcset');
              modalImage.src = radio.dataset.image;
              modalImage.alt = radio.dataset.imageAlt;
            }
            if (updateUrl) {
              const firstBullet = scope.querySelector('.swiper-pagination-bullet');
              if (firstBullet && !firstBullet.classList.contains('swiper-pagination-bullet-active')) firstBullet.click();
            }
          }
          scope.querySelectorAll('.product-form--floating input[name="id"]').forEach(input => {
            input.value = radio.value;
            input.disabled = !available;
          });
          scope.querySelectorAll('.product-form--floating button[name="add"]').forEach(sticky => {
            sticky.disabled = !available;
            sticky.setAttribute('aria-disabled', String(!available));
          });
        }
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url);
        }
      };
      this.addEventListener('change', event => {
        if (radios.includes(event.target)) sync(event.target, true);
        if (event.target === select) sync(radios.find(radio => radio.value === select.value), true);
      });
      sync(radios.find(radio => radio.checked));
      this.classList.add('is-ready');
    }
  });
}
